import { AnyAction } from 'redux';
import { PeopleState } from 'unit-people/interfaces/people-state';
import { INITIAL_STATE, peopleReducerMethods } from 'unit-people/reducer-methods';

export function people(
  state: PeopleState = INITIAL_STATE,
  action: AnyAction,
): PeopleState {
  if (action && action.type in peopleReducerMethods) {
    return peopleReducerMethods[action.type](state, action.payload);
  } else {
    return state;
  }
}
